import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/cross-circle-red.svg'
import _imports_1 from '@/assets/img/icon/check-circle-green.svg'


const _hoisted_1 = { id: "delivery-canceled" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row items-left justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal w-full sm:w-max" }, "Paket Hangus")
], -1)
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = { class: "sm:flex items-center" }
const _hoisted_6 = { class: "text-base color-blue-grey font-bold mr-3" }
const _hoisted_7 = { class: "md:flex items-end justify-between mt-4" }
const _hoisted_8 = { class: "md:w-1/2" }
const _hoisted_9 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-xs color-blue-grey mb-3" }, "Pengirim", -1)
const _hoisted_11 = { class: "text-sm font-bold color-blue-grey" }
const _hoisted_12 = { class: "text-sm font-bold color-blue-grey" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-xs color-blue-grey mb-3" }, "Penerima", -1)
const _hoisted_14 = { class: "text-sm font-bold color-blue-grey" }
const _hoisted_15 = { class: "text-sm font-bold color-blue-grey" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "text-xs color-blue-grey" }, "Jenis", -1)
const _hoisted_17 = {
  class: "font-extrabold color-blue-grey",
  style: {"font-size":"32px"}
}
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "flex items-center sm:justify-end" }
const _hoisted_20 = {
  class: "mr-3 font-extrabold color-blue-grey",
  style: {"font-size":"32px"}
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "text-xl color-blue-grey" }, "Total Koli", -1)
const _hoisted_22 = { class: "flex items-center sm:justify-end" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center ml-3"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 mr-1"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "text-base color-red font-bold mr-3 " }, "Tolak", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "h-5 w-5 mr-1"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "text-base color-green font-bold " }, "Approve", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Card = _resolveComponent("Card")
  const _component_ModalConfirmCancelPackage = _resolveComponent("ModalConfirmCancelPackage")
  const _component_ModalPackageCancelationLog = _resolveComponent("ModalPackageCancelationLog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "delivery-canceled" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari Disini ...",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva,
              class: "mt-3 sm:mt-0"
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ])
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
          return (_openBlock(), _createBlock("div", { key: data }, [
            _createVNode("div", {
              class: "mb-5 devilery-canceled-card p-3",
              style: data.StatusPengirimanKode === 'HGS' ? {'background-color': '#eceff1'} : {'background-color':'#fff'}
            }, [
              _createVNode("div", _hoisted_4, "#" + _toDisplayString(data.Resi), 1),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(data.AgenAsalNama) + " - " + _toDisplayString(data.AgenTujuanNama), 1),
                _createVNode("div", {
                  style: {"width":"fit-content"},
                  class: data.StatusPengirimanKode === 'HGS' ? 'tag-outline-red rounded px-2' : 'tag-outline-orange rounded px-2'
                }, _toDisplayString(data.StatusPengirimanStatus), 3)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", null, [
                      _hoisted_10,
                      _createVNode("div", null, [
                        _createVNode("p", _hoisted_11, _toDisplayString(data.NamaPengirim), 1),
                        _createVNode("p", _hoisted_12, _toDisplayString(data.HpPengirim), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _hoisted_13,
                      _createVNode("div", null, [
                        _createVNode("p", _hoisted_14, _toDisplayString(data.NamaPenerima), 1),
                        _createVNode("p", _hoisted_15, _toDisplayString(data.HpPenerima), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _hoisted_16,
                      _createVNode("div", _hoisted_17, _toDisplayString(data.TipePengiriman), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, _toDisplayString(data.TransPengirimanDetails.length), 1),
                    _hoisted_21
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", {
                      class: "text-base color-primary font-bold cursor-pointer",
                      onClick: ($event: any) => (_ctx.showDetail(data.Id))
                    }, "Lihat Detail Status", 8, ["onClick"]),
                    (data.StatusPengirimanKode !== 'HGS')
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _createVNode("div", {
                            class: "flex items-center cursor-pointer",
                            onClick: ($event: any) => (_ctx.showDialog(data.Id, 0))
                          }, [
                            _hoisted_24,
                            _hoisted_25
                          ], 8, ["onClick"]),
                          _createVNode("div", {
                            class: "flex items-center cursor-pointer",
                            onClick: ($event: any) => (_ctx.showDialog(data.Id, 1))
                          }, [
                            _hoisted_26,
                            _hoisted_27
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 4)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.isShowDialogConfirmCancelPackage)
      ? (_openBlock(), _createBlock(_component_ModalConfirmCancelPackage, {
          key: 0,
          isShowDialog: _ctx.isShowDialogConfirmCancelPackage,
          idPackage: _ctx.requestedConfirmCancelPackage,
          type: _ctx.dialogType,
          onHideDialog: _ctx.hideModalConfirmCancelPackage,
          onReloadData: _ctx.reloadData
        }, null, 8, ["isShowDialog", "idPackage", "type", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.isShowDialogConfirmCancelPackageLog)
      ? (_openBlock(), _createBlock(_component_ModalPackageCancelationLog, {
          key: 1,
          isShowDialog: _ctx.isShowDialogConfirmCancelPackageLog,
          idPackage: _ctx.requestedConfirmCancelPackage,
          onHideDialog: _ctx.hideModalConfirmCancelPackageLog
        }, null, 8, ["isShowDialog", "idPackage", "onHideDialog"]))
      : _createCommentVNode("", true)
  ]))
}